<template>
  <div id="page" class="settleIn2">
    <img class="main_img" src="../assets/header_img.png" alt="">
    <!-- <div class="footer" :class="footer_hide"> -->
    <div class="form_container">
      <div class="form_content">
        <el-form :inline="true" ref="settleInForm" :model="settleInForm">
          <div class="form_header">
            <div class="form_title">填写入驻信息</div>
          </div>
          <div class="form_input_block" @click="handleToken">
            <el-form-item label="联系人" prop="name">
              <el-input placeholder="请输入姓名" ref="nameinput" v-model="settleInForm.name" @blur="settleInFormName"></el-input>
            </el-form-item>
            <el-form-item class="picker_select" prop="area" label="所在地区" @click.native="pickerShowFun()">
              <div>
                <span v-show="countyName" style="color: #333;">
                  {{ provinceName }} - {{ cityName }} - {{ countyName }}
                </span>
                <span v-show="!countyName">请选择地区</span>
              </div>
              <div class="right">
                <i class="el-icon-arrow-right"></i>
              </div>
              <el-input type="text" v-if="0" v-model="settleInForm.area"></el-input>
            </el-form-item>
          </div>

          <div class="upImg_block" v-for="(item,index) in updata" @click="handleToken(true)">
            <div class="upImg_title">{{ item.title }}</div>
            <div class="upImg_item" v-for="(it,i) in item.childList">
              <img class="example" :src="it.exampleImg" alt=""/>
              <div class="upImg_operate">

                <uploadDom :uploadKey="it.name" :status="item.status" :upImgUrl="it.upImgUrl" :token="token"
                           :onBeforeUpload="onBeforeUploadFun" :onSuccess="handleAvatarSuccess"></uploadDom>

              </div>
            </div>
            <div class="error-text" v-if="item.status == 3">驳回原因:{{ item.errorName }}</div>
          </div>

          <el-button class="submit" type="primary" @click="onSubmit('settleInForm')">提交</el-button>
        </el-form>
      </div>
    </div>
    <div class="mask" v-if="pickerShowState">
      <div class="picker_contet">
        <div class="picker_header">
          <div @click="pickerShowState=false">取消</div>
          <div></div>
          <div @click="pickerConfirm()">确定</div>
        </div>
        <mt-picker :itemHeight="50" value-key="label" :slots="slots" @change="onValuesChange"></mt-picker>
      </div>
    </div>
    <div class="load_mask mask" v-if="load_show">
      <div class="load_content">
        <div class="loader-inner ball-clip-rotate">
          <div></div>
        </div>
        <div class="load_text">正在提交,请稍等</div>
      </div>
    </div>
    <div class="success_mask mask" v-if="successToast_show">
      <div class="successToast">
        <div class="success_header">
          <i class="el-icon-close" @click="cancel" style="font-size: 3.57rem;color: #444444;"></i>
        </div>
        <div class="success_icon">
          <i class="el-icon-success" style="font-size: 7.66rem;color: #23B423;"></i>
        </div>
        <div class="success_prompt">
          <div>提交成功，请保持电话畅通</div>
          <div>1-2个工作日会有客服人员联系您</div>
        </div>
        <div class="success_schedule_prompt">
          如要获悉实时审核进度
        </div>
        <div class="success_triangle">
          <i style="font-size: 2.3rem;color: #C5C5C5;" class="el-icon-caret-bottom"></i>
        </div>
        <div class="success_vrCode_block">
          <img src="../assets/vrcode.png" alt="">
          <div class="success_vrCode_text">
            <div>长按添加客服微信</div>
            <div style="color: #FFC43E;">@送水骑士</div>
          </div>
        </div>
        <div class="confirm" @click="cancel">
          好的
        </div>
      </div>
    </div>

    <mt-popup
        v-model="popupVisible"
        class="popup-mt"
        popup-transition="popup-fade">
      <div class="form_title">请填写入手机号</div>
      <el-input placeholder="请输入手机号码" ref="inputf" v-model="settleInForm.phone"></el-input>
      <div class="vcode_item">
        <el-input placeholder="请输入验证码" v-model="settleInForm.vcode"></el-input>
        <div class="getCode color1" v-if="timeOut == 0" @click="getCode">获取验证码</div>
        <div class="getCode color2" v-else>重新获取({{ timeOut }})</div>
      </div>
      <el-button class="submit" type="primary" @click="handlePhone()">提交</el-button>
    </mt-popup>
  </div>
</template>
<script>
import {
  Toast,
  Indicator
} from 'mint-ui';
import slots from "../util/area/slots"
import city from "../util/area/city"
import county from "../util/area/county"
import uploadDom from "../components/upload"
import {
  submitSettled2,
  sendVcode,
  shares,
  upSettled2, verifyCode
} from '../request/api';
import wx from 'weixin-js-sdk';
import VConsole from 'vconsole';

export default {
  components: {
    uploadDom
  },
  data() {
    // let checkPhone = (rule, value, callback) => {
    //     let phoneRegExp = /^1[3456789]\d{9}$/
    //     if (!phoneRegExp.test(value)) {
    //         return callback(new Error('请输入正常手机号格式'));
    //     } else{
    //         callback();
    //     }
    // }
    return {
      token: '',
      popupVisible: false,
      checkUpload: [],
      data_img: {
        file_license: "",
        file_permit: "",
        file_identity_front: "",
        file_identity_back: "",
        file_doorstep: "",
        file_doorstep_two: "",
        file_doorstep_three: ""
      },
      id: "",
      settleInForm: {
        name: "",
        phone: "",
        area: "",
        vcode: ""
      },
      slots: slots,
      areaValues: [{
        value: ""
      }, {
        value: ""
      }, {
        value: ""
      }],
      provinceName: "",
      cityName: "",
      countyName: "",
      pickerShowState: false,

      source: "",
      formdata: "",
      load_show: false,
      successToast_show: false,

      updata: [],
      upDataIndex: 0,
      upDataChildIndex: 0,

      licenseImg: "",
      licenseImgUrl: "",

      permitImg: "",
      permitImgUrl: "",

      storeImg: "",
      storeImgUrl: "",

      timeOut: 0,
      countdown: "",
      user_share_code:'',    //分享的邀请码
      locationHref:"",
    }
  },

  created() {

    // console.log(this.getQueryString('userShareCode'),'获取地址栏的参数')
    this.user_share_code = this.getQueryString('userShareCode');
    this.locationHref = window.location.href;

    this.updata = [{
      errorName: '',
      status: 2,
      title: "营业执照（必填）",
      childList: [{
        exampleImg: require("../assets/license.png"),
        upImgUrl: "",
        upImgFile: "",
        name: "license",
        id: 1
      }]
    }, {
      errorName: '',
      status: 2,
      title: "食品经营许可证（选填）",
      childList: [{
        exampleImg: require("../assets/permit.png"),
        upImgUrl: "",
        upImgFile: "",
        name: "permit",
        id: 2
      }]
    }, {
      errorName: '',
      status: 2,
      title: "法人身份证正反面（必填）",
      childList: [{
        exampleImg: require("../assets/idcard1.png"),
        upImgUrl: "",
        upImgFile: "",
        name: "identity_front",
        id: 3
      },
        {
          exampleImg: require("../assets/idcard2.png"),
          upImgUrl: "",
          upImgFile: "",
          name: "identity_back",
          id: 4
        }
      ]
    }, {
      errorName: '',
      status: 2,
      title: "门店照-三张（必填）",
      childList: [{
        exampleImg: require("../assets/store1.png"),
        upImgUrl: "",
        upImgFile: "",
        name: "doorstep_one",
        id: 5
      }, {
        exampleImg: require("../assets/store2.png"),
        upImgUrl: "",
        upImgFile: "",
        name: "doorstep_two",
        id: 6
      },
        {
          exampleImg: require("../assets/store3.png"),
          upImgUrl: "",
          upImgFile: "",
          name: "doorstep_three",
          id: 7
        }
      ]
    },]

  },

  mounted() {

    document.title = "送水骑士 | 桶装水门店入驻";

    this.getShareInfo()
    let source = this.$route.query.source;
    if (source) {
      this.source = source
    }
    // const vConsole = new VConsole();
    window.localStorage.getItem('license')

    console.log(window.localStorage,'获取缓存',window.localStorage.getItem('token'));

    let tokenTime = window.localStorage.getItem('token_time')
    if (!tokenTime || tokenTime < 0 || tokenTime < (Date.parse(new Date()) / 1000)) {
      window.localStorage.clear()
    }

    if(window.localStorage.getItem('token')){
      this.token = window.localStorage.getItem('token');

      this.settleInForm.name = window.localStorage.getItem('contacts');
      this.areaValues[0].value = window.localStorage.getItem('province');
      this.areaValues[1].value = window.localStorage.getItem('city');
      this.areaValues[2].value = window.localStorage.getItem('area');
      this.provinceName = window.localStorage.getItem('provinceName');
      this.cityName = window.localStorage.getItem('cityName');
      this.countyName = window.localStorage.getItem('countyName');

      this.updata[0]["childList"][0]["upImgUrl"] = window.localStorage.getItem('license');
      this.updata[1]["childList"][0]["upImgUrl"] = window.localStorage.getItem('permit');
      this.updata[2]["childList"][0]["upImgUrl"] = window.localStorage.getItem('identity_front');
      this.updata[2]["childList"][1]["upImgUrl"] = window.localStorage.getItem('identity_back');
      this.updata[3]["childList"][0]["upImgUrl"] = window.localStorage.getItem('doorstep_one');
      this.updata[3]["childList"][1]["upImgUrl"] = window.localStorage.getItem('doorstep_two');
      this.updata[3]["childList"][2]["upImgUrl"] = window.localStorage.getItem('doorstep_three');

      this.updata[0].status = window.localStorage.getItem('license') ? '' : 2
      this.updata[1].status = window.localStorage.getItem('permit') ? '' : 2
      this.updata[2].status = (window.localStorage.getItem('identity_front') || window.localStorage.getItem('identity_back')) ? '' : 2
      this.updata[3].status = (window.localStorage.getItem('doorstep_one') || window.localStorage.getItem('doorstep_two') || window.localStorage.getItem('doorstep_three') ) ?  '' : 2



    }
  },
  methods: {

    //region 主要用户获取地址栏，邀请码的参数
    getQueryString(name) {
      // 未传参，返回空   获取地址栏的参数
      if (!name) return null;
      // 查询参数：先通过search取值，如果取不到就通过hash来取
      var after = window.location.search;
      after = after.substr(1) || window.location.hash.split("?")[1];
      // 地址栏URL没有查询参数，返回空
      if (!after) return null;
      // 如果查询参数中没有"name"，返回空
      if (after.indexOf(name) === -1) return null;
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      // 当地址栏参数存在中文时，需要解码，不然会乱码
      var r = decodeURI(after).match(reg);
      // 如果url中"name"没有值，返回空
      if (!r) return null;
      return r[2];
    },
    //endregion


    settleInFormName(){
      //失去光标就缓存名称
      console.log(this.settleInForm.name,'设置了缓存名称')
      window.localStorage.setItem('contacts',this.settleInForm.name)
    },


    handleAvatarSuccess(res) {
      if (res.data.path) {
        switch (res.data.params) {
          case "license":
            this.updata[0].status = 0
            this.updata[0]["childList"][0]["upImgUrl"] = res.data.path
            window.localStorage.setItem('license',res.data.path);  //缓存营业执照
            break;
          case "permit":
            this.updata[1].status = 0
            this.updata[1]["childList"][0]["upImgUrl"] = res.data.path
            window.localStorage.setItem('permit',res.data.path);  //缓存食品经营许可证
            break;
          case "identity_front":
            this.updata[2].status = 0
            this.updata[2]["childList"][0]["upImgUrl"] = res.data.path
            window.localStorage.setItem('identity_front',res.data.path);  //缓存身份证正面
            break;
          case "identity_back":
            this.updata[2].status = 0
            this.updata[2]["childList"][1]["upImgUrl"] = res.data.path
            window.localStorage.setItem('identity_back',res.data.path);  //缓存身份证反面
            break;
          case "doorstep_one":
            this.updata[3].status = 0
            this.updata[3]["childList"][0]["upImgUrl"] = res.data.path
            window.localStorage.setItem('doorstep_one',res.data.path);  //缓存店面第一张
            break;
          case "doorstep_two":
            this.updata[3].status = 0
            this.updata[3]["childList"][1]["upImgUrl"] = res.data.path
            window.localStorage.setItem('doorstep_two',res.data.path);  //缓存店面第二张
            break;
          case "doorstep_three":
            this.updata[3].status = 0
            this.updata[3]["childList"][2]["upImgUrl"] = res.data.path
            window.localStorage.setItem('doorstep_three',res.data.path);  //缓存店面第二张
            break;
          default:
            break;
        }

        let index = this.checkUpload.indexOf(res.data.params);
        if (index !== -1) {
          this.checkUpload.splice(index, 1);
        }
      }
    },
    onValuesChange(picker, values) {
      let cityIndex = values[0].index
      let countyIndex = values[1].index
      picker.setSlotValues(1, city[cityIndex])
      picker.setSlotValues(2, county[cityIndex][countyIndex])
      this.areaValues = values

    },

    getShareInfo() {
      shares({
        url: location.href
      }).then(res => {
        const config = res.data;
        wx.config({
          debug: false,
          appId: config.appId, // appID 公众号的唯一标识
          timestamp: config.timestamp, // 生成签名的时间戳
          nonceStr: config.nonceStr, //  生成签名的随机串
          signature: config.signature, // 生成的签名
          jsApiList: [
            'updateAppMessageShareData', // 分享到朋友
            'updateTimelineShareData', // 分享到朋友圈
          ]
        });

        wx.ready(() => {
          let shareData = {
            title: '送水骑士 | 桶装水门店入驻',
            desc: '帮助水店获客，提高30%营收，0费用，0扣点。',
            link: "http://h5.songshuiqishi.com/#/settleIn2?source=2", // 分享后的地址
            imgUrl: config.logo,
            success: function (res) {
            }

          };
          //点击要去分享
          wx.updateAppMessageShareData(shareData);
          wx.updateTimelineShareData(shareData);
        })
      });
    },

    pickerConfirm() {
      this.pickerShowState = false
      this.settleInForm.area = true
      this.provinceName = this.areaValues[0].label
      this.cityName = this.areaValues[1].label
      this.countyName = this.areaValues[2].label

      window.localStorage.setItem('province',this.areaValues[0].value); //设置省缓存
      window.localStorage.setItem('city',this.areaValues[1].value);     //设置市缓存
      window.localStorage.setItem('area',this.areaValues[2].value);     //设置区缓存
      window.localStorage.setItem('provinceName',this.areaValues[0].label);  //缓存省名称
      window.localStorage.setItem('cityName',this.areaValues[1].label);  //缓存市名称
      window.localStorage.setItem('countyName',this.areaValues[2].label);  //缓存区名称
    },

    handlePhone() {
      if (!this.settleInForm.phone) {
        Toast({
          message: "请输入手机号",
          duration: 2000,
          iconClass: 'icon el-icon-error'
        });
        return
      }
      let phonen = /^1[3456789][0-9]{9}$/
      if (!phonen.test(this.settleInForm.phone)) {
        Toast({
          message: "请输入正确手机号",
          duration: 2000,
          iconClass: 'icon el-icon-error'
        });
        return
      }

      if (!this.settleInForm.vcode) {
        Toast({
          message: "请输入验证码",
          duration: 2000,
          iconClass: 'icon el-icon-error'
        });
        return
      }

      verifyCode({
        mobile: this.settleInForm.phone,
        code: this.settleInForm.vcode
      })
          .then(res => {
            this.token = res.data.token;
            console.log(res.data.token,'是否有设只了token')
            window.localStorage.setItem('token',res.data.token);   //缓存token值
            window.localStorage.setItem('phone',this.settleInForm.phone);   //缓存手机号码缓存
            window.localStorage.setItem('token_time', (Date.parse(new Date()) / 1000) + 86400)

            this.updata[0]["childList"][0]["upImgUrl"] = res.data.file_license
            this.updata[1]["childList"][0]["upImgUrl"] = res.data.file_permit
            this.updata[2]["childList"][0]["upImgUrl"] = res.data.file_identity_front
            this.updata[2]["childList"][1]["upImgUrl"] = res.data.file_identity_back
            this.updata[3]["childList"][0]["upImgUrl"] = res.data.file_doorstep
            this.updata[3]["childList"][1]["upImgUrl"] = res.data.file_doorstep_two
            this.updata[3]["childList"][2]["upImgUrl"] = res.data.file_doorstep_three

            this.updata[0].errorName = res.data.file_license_reject
            this.updata[1].errorName = res.data.file_permit_reject
            this.updata[2].errorName = res.data.file_identity_reject
            this.updata[3].errorName = res.data.file_doorstep_reject

            this.updata[0].status = res.data.file_license_status
            this.updata[1].status = res.data.file_permit_status
            this.updata[2].status = res.data.file_identity_status
            this.updata[3].status = res.data.file_doorstep_status
            this.areaValues[0].value = res.data.province
            this.areaValues[1].value = res.data.city
            this.areaValues[2].value = res.data.area
            this.settleInForm.name = res.data.contacts
            this.provinceName = res.data.province_name
            this.cityName = res.data.city_name
            this.countyName = res.data.area_name
            this.popupVisible = false;

            Toast({
              message: '提交成功',
              duration: 2000,
              iconClass: 'icon el-icon-success'
            });
          })
          .catch(e => {
            Toast({
              message: e.msg,
              duration: 2000,
              iconClass: 'icon el-icon-error'
            });
          })
    },

    onSubmit() {
      if (this.token == '') return this.popupVisible = true

      if (!this.settleInForm.name) {
        Toast({
          message: "请填写名称",
          duration: 2000,
          iconClass: 'icon el-icon-error'
        });
        return
      }

      if (!this.areaValues[1].value) {
        Toast({
          message: "请填写地址",
          duration: 2000,
          iconClass: 'icon el-icon-error'
        });
        return
      }
      console.log(this.checkUpload)
      if (this.checkUpload.length > 0) {
        Toast({
          message: "图片上传中,请稍后再提交",
          duration: 2000,
          iconClass: 'icon el-icon-error'
        });
        return
      }

      if (!this.updata[0].childList[0].upImgUrl) {
        Toast({
          message: "请上传营业执照",
          duration: 2000,
          iconClass: 'icon el-icon-error'
        });
        return
      }

      // 设置法人照片
      let identity = this.updata[2]
      let identityArr = []
      identity.childList.forEach(item => {
        identityArr.push(item.upImgUrl)
      })
      let identityNewarr = identityArr.filter(function (item, index, arre) {
        return item !== ""
      })
      if (identityNewarr.length != 2) {
        Toast({
          message: "请上传法人身份照片",
          duration: 2000,
          iconClass: 'icon el-icon-error'
        });
        return
      }

      // 设置门店照片必传
      let doors = this.updata[3]
      let doorstepArr = []
      doors.childList.forEach(item => {
        doorstepArr.push(item.upImgUrl)
      })
      let doorstepNewarr = doorstepArr.filter(function (item, index, arre) {
        return item !== ""
      })
      if (doorstepNewarr.length != 3) {
        Toast({
          message: "请上传门店照",
          duration: 2000,
          iconClass: 'icon el-icon-error'
        });
        return
      }

      let param = {
        token: this.token,
        // source: this.source,
        contacts: this.settleInForm.name,
        mobile: this.settleInForm.phone,
        province: this.areaValues[0].value,
        city: this.areaValues[1].value,
        area: this.areaValues[2].value,
        file_license: this.updata[0].childList[0].upImgUrl,
        file_permit: this.updata[1].childList[0].upImgUrl,
        file_identity_front: this.updata[2].childList[0].upImgUrl,
        file_identity_back: this.updata[2].childList[1].upImgUrl,
        file_doorstep: this.updata[3].childList[0].upImgUrl,
        file_doorstep_two: this.updata[3].childList[1].upImgUrl,
        file_doorstep_three: this.updata[3].childList[2].upImgUrl,
        // code: this.settleInForm.vcode,
        user_share_code:this.user_share_code ? this.user_share_code : "",
      }

      window.localStorage.setItem('contacts',this.settleInForm.name);  //设置姓名缓存
      window.localStorage.setItem('province',this.areaValues[0].value); //设置省缓存
      window.localStorage.setItem('city',this.areaValues[1].value);     //设置市缓存
      window.localStorage.setItem('area',this.areaValues[2].value);     //设置区缓存

      this.load_show = true

      submitSettled2(param).then((res) => {
        this.load_show = false
        this.$router.push("/settleInSuccess")
        this.successToast_show = true
        if (res.code == 0) {
          Toast({
            message: '提交成功',
            duration: 2000,
            iconClass: 'icon el-icon-success'
          });


           window.localStorage.clear();  //提交成功后，清除所有缓存


        }
      }).catch(() => {
        this.load_show = false
      })

    },

    handleToken() {
      if (this.token == '') {
        event.preventDefault()
        this.$refs.nameinput.blur()
        this.popupVisible = true;
        this.$nextTick(() => {
          this.$refs.inputf.focus()
        })
      }
    },

    async getCode() {
      let data

      if (this.timeOut != 0) return

      Indicator.open();

      data = await sendVcode({
        mobile: this.settleInForm.phone
      })

      Indicator.close();

      if (data.code != 0) return

      this.timeOut = 60
      this.countdown = setInterval(() => {
        this.timeOut--
        if (this.timeOut == 0) {
          clearInterval(this.countdown)
        }
      }, 1000)
    },

    pickerShowFun() {
      if (this.token == '') {
        this.$nextTick(() => {
          this.$refs.inputf.focus()
        })
        this.popupVisible = true
        return
      }
      this.pickerShowState = true
    },
    cancel() {
      this.successToast_show = false
    },

    onBeforeUploadFun(key) {
      this.checkUpload.push(key)
    },
  }

}
</script>
<style lang="less">
.mint-indicator-wrapper {
  z-index: 99 !important;
}

.settleIn2 {
  .main_img {
    width: 100vw;
    height: auto;
  }

  .btn_img_container {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  @keyframes btn_img_animation {
    0% {
      transform: scale(90%);
    }

    100% {
      transform: scale(100%);
    }
  }

  .btn_img {
    width: 56.5rem;
    height: 9.1rem;
    position: absolute;
    top: 0;
    z-index: 2;
    top: 79.1rem;
    animation-name: btn_img_animation;
    animation-duration: 700ms;
    animation-iteration-count: infinite;
    animation-direction: alternate-reverse;
    animation-timing-function: linear;
  }

  @keyframes footerAnimation {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(12.2rem);
    }
  }

  @keyframes footerAnimationRe {
    0% {
      transform: translateY(12.2rem);
    }

    100% {
      transform: translateY(0);
    }
  }

  .footer {
    width: 100vw;
    height: 12.2rem;
    position: fixed;
    bottom: 0;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5ms;
    box-shadow: 0rem 0.3rem 2.6rem -0.9rem rgba(0, 0, 0, 0.36);
  }

  .footer_hideRe {
    animation-name: footerAnimationRe;
    animation-duration: 500ms;
    animation-fill-mode: forwards;
  }

  .footer_hide {
    animation-name: footerAnimation;
    animation-duration: 500ms;
    animation-fill-mode: forwards;
  }

  .join_btn {
    width: 63.1rem;
    height: 8.8rem;
    background: linear-gradient(to right, #0980E8, #2BA4F9);
    color: #fff;
    border-radius: 4.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    font-size: 3.6rem;
  }

  .form_container {
    background-color: #fff;
    width: 100vw;
    bottom: 0;
    border-radius: 2rem 2rem 0 0;
  }

  .form_content {
    margin: 2.6rem 5rem 4rem;

    .form_header {
      display: flex;
      justify-content: center;
      align-items: center;

      .form_close {
        position: absolute;
        right: 3rem;
      }

      .form_title {
        color: #333333;
        font-size: 3.2rem;
        letter-spacing: 0.3rem;
        font-weight: 600;
      }
    }

    .el-checkbox__inner::after {
      left: 0.9rem;
      top: 0.4rem;
    }

    .el-form-item__error {
      z-index: 2;
    }

    .el-form-item__label {
      flex-basis: 16rem;
      letter-spacing: 1.1rem;
    }

    .form_input_block {
      margin: 2rem 0;

      .el-form-item {
        width: 100%;
        display: flex;
        margin-bottom: 2rem;
      }

      .el-form-item__content {
        flex-grow: 1;
      }

      .el-input__inner {
        border: 0;
        border-bottom: 1px solid #E5E5E5;
        width: 100%;
        padding: 0;
        padding-left: 3rem;
        border-radius: 0;
      }

      .el-input.is-disabled .el-input__inner {
        background: #fff;
      }

      .picker_select {
        display: flex;

        .el-form-item__label {
          letter-spacing: normal;
        }

        .el-form-item__content {
          border-bottom: 1px solid #E5E5E5;
          padding-left: 3rem;
          color: #C0C4CC;
        }

        .right {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }

      .el-form-item__label {
        width: 14rem;
        text-align: left;
      }
    }

    .vcode_item {
      display: flex;
      border-bottom: 1px solid #E5E5E5;

      .el-input__inner {
        border-bottom: none;
        width: 25rem;
      }

      .getCode {
        flex-shrink: 0;
        flex-grow: 1;
        position: absolute;
        right: 0;
      }
    }

    .upImg_block {
      margin-top: 5.5rem;

      .error-text {
        font-size: 2.2rem;
        color: red;
        padding-left: 51%;
      }

      .upImg_title {
        font-size: 2.8rem;
        color: #606266;
        padding-bottom: 2.2rem;
        border-bottom: 1px solid #EEEEEE;
        margin-bottom: 2.4rem;
      }

      .example {
        width: 49%;
        height: 20rem;
      }

      .upImg_operate {
        width: 49%;
        height: 20rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #F6F6F7;

      }

      .upImg_item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 2rem;
      }

      .upimg_block {
        width: 100%;
        height: 100%;
      }

      .upImg_uploader {
        width: 100%;
        height: 100%;
      }


      .el-upload {
        width: 100%;
        height: 100%;
      }

      .box-upload {
        width: 100%;
        height: 100%;
        position: relative;
      }

      .weImg {
        opacity: .6;
      }

      .we1 {
        color: #FFFFFF;
      }

      .we2 {
        color: #df2929;
      }

      .tg {
        position: absolute;
        left: 0;
        top: 0;
        width: 7rem;
        height: 7rem;
      }

      .we {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: #919191;
        padding: 1.7rem;
        font-size: 2.5rem;
        border-radius: 1rem;
      }

      .el-upload {
        width: 100%;
        height: 100%;
      }

      .upimg_btn {
        width: 100%;
        height: 100%;
        background-color: #F6F6F7;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .submit {
      width: 100%;
      height: 8.8rem;
      border-radius: 4.4rem;
      margin-top: 3rem;
      font-size: 3.6rem;
    }
  }

  .mask {
    background: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;

    .picker_header {
      display: flex;
      justify-content: space-between;
      font-size: 3rem;
      margin: 4rem 6rem 0;
      padding-bottom: 2rem;
    }

    .picker_contet {
      width: 100vw;
      height: 52rem;
      background-color: #fff;
      position: absolute;
      bottom: 0;
    }
  }

  .mint-toast-icon {
    font-size: 8rem;
  }

  .load_mask {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .load_content {
    width: 34vw;
    height: 12vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 1rem;

    .load_text {
      color: #fff;
      font-size: 2.8rem;
    }

    .ball-clip-rotate > div {
      background-color: #fff;
      width: 15px;
      height: 15px;
      border-radius: 100%;
      margin: 2px;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
      border: 2px solid #fff;
      border-bottom-color: transparent;
      height: 25px;
      width: 25px;
      background: transparent !important;
      display: inline-block;
      -webkit-animation: rotate 0.75s 0s linear infinite;
      animation: rotate 0.75s 0s linear infinite;
    }

    @keyframes rotate {
      0% {
        -webkit-transform: rotate(0deg) scale(1);
        transform: rotate(0deg) scale(1);
      }

      50% {
        -webkit-transform: rotate(180deg) scale(0.6);
        transform: rotate(180deg) scale(0.6);
      }

      100% {
        -webkit-transform: rotate(360deg) scale(1);
        transform: rotate(360deg) scale(1);
      }
    }

  }

  .success_mask {
    display: flex;
    justify-content: center;
    align-items: center;

    .successToast {
      width: 70vw;
      border-radius: 1rem;
      padding: 3.6rem;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .success_header {
      display: flex;
      justify-content: end;
      width: 100%;
    }

    .success_icon {
    }

    .success_prompt {
      font-size: 2.8rem;
      text-align: center;
      margin-top: 2.2rem;
      line-height: 1.5;
      margin-bottom: 4.2rem;
    }

    .success_schedule_prompt {
      color: #999999;
      font-size: 2.3rem;
    }

    .success_triangle {
      margin-bottom: 1.9rem;
      font-size: 0;
    }

    .success_vrCode_block {
      width: 80%;
      padding: 1.9rem;
      box-shadow: 0rem 1.5rem 2.8rem 0.1rem rgba(0, 0, 0, 0.05);
      border-radius: 1rem;
      color: #444444;
      font-size: 2.8rem;
      display: flex;
      align-items: center;

      .success_vrCode_text {
        margin-left: 4.6rem;
        line-height: 1.5;
      }

      img {
        width: 11.5rem;
        height: 11.5rem;
      }
    }
  }

  .confirm {
    width: 80%;
    height: 8.8rem;
    border-radius: 4.4rem;
    margin-top: 3rem;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3.2rem;
    font-size: 3.6rem;
    background: linear-gradient(to right, #0980E8, #2BA4F9);
  }

  .popup-mt {
    z-index: 10 !important;
    width: 80%;
    border-radius: 1.8rem;
    padding: 4rem;
    box-sizing: border-box;

    .form_title {
      text-align: center;
      color: #333333;
      font-size: 3.2rem;
    }

    .el-input {
      margin-top: 3rem;
    }

    .el-input__inner {
      border-radius: 20px;
      height: 44px;
    }

    .vcode_item {
      display: flex;
      position: relative;

      .getCode {
        flex-shrink: 0;
        flex-grow: 1;
        position: absolute;
        right: 10%;
        top: 50%;
        transform: translateY(-7%);
        font-size: 2.5rem;
      }

      .color1 {
        color: #178FEF;
        font-weight: bold;
      }

      .color2 {
        color: #9a9a9a;
      }
    }

    .submit {
      width: 100%;
      height: 8.5rem;
      border-radius: 4.4rem;
      margin-top: 3rem;
      font-size: 3.6rem;
    }
  }

  .v-modal {
    z-index: 9 !important;
  }

}
</style>



// WEBPACK FOOTER //
// src/page/settleIn2.vue